import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import AddCircle from "@material-ui/icons/AddCircle";
import PriorityListTableActions from "./components/table-action";
import SearchField from "../components/search-field";
import { usePriorityStyles } from "../styles";
import { usePriorityListStyles } from "./styles";
import CustomPagination from "../../../Components/pagination";
import { useBreadcrumbs } from "../../../contexts/breadcrumb";
import EmptyState from "../../../Components/EmptyState";
import { usePermission } from "../../../hooks/usePermission";
import { usePriorityList } from "../../../services/api-tansquery/priority/list";
import Accessible from "@material-ui/icons/Accessible";

export default function PriorityList() {
  const history = useHistory();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { pathname } = useLocation();
  const { isAboveCoordenator } = usePermission();
  const { classes } = usePriorityListStyles();
  const { classes: defaultClasses } = usePriorityStyles();
  const { data: priorityList, isLoading } = usePriorityList();

  const isEmpty = (priorityList?.results ?? []).length === 0;

  useEffect(() => {
    setBreadcrumbs((prev) => {
      const homeBreadcrumb = prev.find((_, index) => index === 0);
      return [
        homeBreadcrumb,
        {
          label: "Prioridades",
          path: "/prioridades",
          icon: Accessible,
        },
      ];
    });
  }, [setBreadcrumbs]);

  return (
    <Box>
      <Box className={classes.header}>
        <Typography className={classes.title}>
          Prioridades de Agendamento
        </Typography>
        {isAboveCoordenator && (
          <Button
            startIcon={<AddCircle />}
            className={defaultClasses.addButton}
            onClick={() => history.push(`${pathname}/novo`)}
          >
            Nova Prioridade
          </Button>
        )}
      </Box>
      <Paper elevation={3}>
        <SearchField placeholder="Buscar por nome ou descrição..." />
        <TableContainer className={defaultClasses.tableContainer}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell className={defaultClasses.tableTH}>
                  Nome
                </TableCell>
                <TableCell className={defaultClasses.tableTH}>
                  Descrição
                </TableCell>
                <TableCell className={defaultClasses.tableTH}>
                  Peso
                </TableCell>
                <TableCell className={defaultClasses.tableTH}>
                  Ativo
                </TableCell>
                <TableCell className={defaultClasses.tableTH} />
              </TableRow>
            </TableHead>
            <TableBody>
              {priorityList?.results.map((priority) => (
                <TableRow key={priority.id} hover>
                  <TableCell className={defaultClasses.tableCell}>
                    {priority.nome}
                  </TableCell>
                  <TableCell className={defaultClasses.tableCell}>
                    {priority.descricao}
                  </TableCell>
                  <TableCell className={defaultClasses.tableCell}>
                    {priority.peso}
                  </TableCell>
                  <TableCell className={defaultClasses.tableCell}>
                    <Box
                      className={`${defaultClasses.badge} ${priority.ativo
                        ? defaultClasses.active
                        : defaultClasses.inactive
                        }`}
                    >
                      {priority.ativo ? "Sim" : "Não"}
                    </Box>
                  </TableCell>
                  <TableCell className={defaultClasses.tableCell}>
                    <PriorityListTableActions
                      priority={priority}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {isEmpty && (
            <EmptyState
              loading={isLoading}
              loadingText="Carregando prioridades..."
              message="Nenhuma prioridade encontrada."
            />
          )}
        </TableContainer>
        <Box className={defaultClasses.paginationContainer}>
          <CustomPagination
            count={priorityList?.count}
            page={priorityList?.current}
            totalPages={priorityList?.total_pages}
          />
        </Box>
      </Paper>
    </Box>
  );
}
